import {ESLLineClamp, ESLLineClampAlt, ESLLineClampToggler} from '@exadel/esl/modules/esl-line-clamp/core';

export default {
  initialize: () => {
    ESLLineClamp.DEFAULT_MASK = '@XS|@SM|@MD|@LG|@XL';
    ESLLineClamp.register();
    ESLLineClampAlt.register();
    ESLLineClampToggler.register();
  }
};
